import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class DattoConfigEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspDattoConfig),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/datto/config').pipe(
                    map((data) => actions.loadMspDattoConfigSuccess({ data })),
                    catchError((error) => of(actions.loadMspDattoConfigFailure({ error }))),
                ),
            ),
        ),
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateMspDattoConfig),
            mergeMap(({ data }) =>
                this.ajax.put('/api/octiga/v3/msp/datto/config', data).pipe(
                    map(() => actions.updateMspDattoConfigSuccess()),
                    catchError((error) => of(actions.updateMspDattoConfigFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
